import { render, staticRenderFns } from "./EditChecklistSettingsForm.vue?vue&type=template&id=44f808c3&"
import script from "./EditChecklistSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./EditChecklistSettingsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports